import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {User} from '../../models/user.model';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {CommonUtils} from '../../utils/common';
import {UserService} from '../../providers/user.service';
import {Subscription} from 'rxjs';
import {mobilePhoneNumberValidator, mustMatch, pwdValidator} from '../../utils/form-validators';
import {ModalController, ToastController} from '@ionic/angular';
import {VetClinicService} from '../../providers/vet-clinic.service';
import {VetClinicStartContextData} from '../../models/vet-clinic-start-context-data.model';
import {ClientsService} from '../../providers/clients.service';
import {Client} from '../../models/client.model';
import {tap} from 'rxjs/operators';
import {AppStateService} from '../../providers/app-state.service';
import {VetClinic} from '../../models/vet-clinic.model';
import {Partner} from '../../models/partner.model';
import {ItemFinderComponent} from '../item-finder/item-finder.component';


@Component({
  selector: 'app-edit-user',
  templateUrl: './edit-user.component.html',
  styleUrls: ['./edit-user.component.scss'],
})
export class EditUserComponent implements OnInit, OnDestroy {

  @Input() user: User;
  @Input() csrfToken: string;
  @Input() isMyUser: boolean;
  clients: Client[] | Partner[];
  clientsSub: Subscription;
  @Input() vClientId: string;

  private userGroup: FormGroup;
  private vetClinicStartContext: VetClinicStartContextData;
  private vetClinicStartContextSub: Subscription;
  private userSub: Subscription;
  private hasUnsavedChanges = false;


  @Output() userEditedEmitter = new EventEmitter<User>();
  @Output() userEditCanceledEmitter = new EventEmitter<Boolean>();
  @Output() hasUnsavedChangesEmitter = new EventEmitter<boolean>();
  private loggedUser: User;
  private isAdmin: boolean;
  isGeneralAdmin: boolean;
  isGeneralUserAdmin: boolean;
  roles: string[];
  isBusy: boolean;
  isBusySub: Subscription;
  pwdType = 'password';
  showPwdIcon: string = 'eye-off-outline';
  pwdSub: Subscription;
  clientSelected: Client | Partner ;
  clinicSelected: VetClinic;
  clinics: VetClinic[];
  clinicSub: Subscription;
  vetcodeId: string;
  partnerBannerActions: boolean;
  isArticleModeEnabled: boolean;
  canAddWellnessPlanRoles: boolean = false;
  checkCarePlanSub: Subscription;
  recommendationSystem: boolean = false;

  constructor(
    public commonUtils: CommonUtils,
    private formBuilder: FormBuilder,
    private userService: UserService,
    private toastController: ToastController,
    private vetClinicService: VetClinicService,
    private clientService: ClientsService,
    private appStateService: AppStateService,
    private modalController: ModalController
  ) {
  }

  ngOnInit() {
    this.isBusySub = this.appStateService.isBusySubject.subscribe(isBusy => {
      this.isBusy = isBusy;
    });
    console.log(this.user);
    this.vetcodeId = this.user?.vetcodeId;

    if (this.isMyUser) {
      this.prepareMyUser();
    }
    this.vetClinicStartContextSub = this.vetClinicService.getVetClinicStartContextData().subscribe((vetClinicStartContext) => {
      this.vetClinicStartContext = vetClinicStartContext;
    });

    this.userSub = this.userService.getUser().subscribe(it => {
        this.loggedUser = this.commonUtils.bestTypedCopyEver<User>(new User(), it);
        this.isAdmin = this.loggedUser.roles.split(';').filter(e => e === 'admin').length === 1;
        this.isGeneralAdmin = this.isAdmin && this.loggedUser.vClientId === null && this.loggedUser.vetcodeId === null;
        this.isGeneralUserAdmin = this.loggedUser.vClientId === null && this.loggedUser.vetcodeId === null;

      this.checkCarePlanSub = this.userService.checkCarePlanEnabled().subscribe(e=> {
        if (e) {
          this.canAddWellnessPlanRoles = true;
          this.handleRoles();
        }
      });

      }
    );

    this.handleRoles();

    if(!this.isMyUser){
      if(this.user.isPartnerType){
        this.appStateService.updateIsBusySubject(true);
        if(this.isGeneralAdmin || this.isGeneralUserAdmin){
          this.clientsSub = this.clientService.listAllPartners().subscribe(vClients => {
              this.appStateService.updateIsBusySubject(false);
              if (this.vClientId) {
                this.clients = vClients.filter(it => (it.id.toString()) == this.vClientId);
                this.clientSelected = this.clients.filter(e => e.id.toString() == this.user.vClientId)[0];
                this.partnerBannerActions = (this.clientSelected as Partner).partnerBannerActions;
                this.isArticleModeEnabled = (this.clientSelected as Partner).isArticleModeEnabled;
                this.handleRoles();
              } else {
                this.clients = vClients;
                console.log(this.clients);
                console.log(this.user);
                this.clientSelected = this.clients.filter(e => e.id.toString() == this.user.vClientId)[0];
                this.partnerBannerActions = (this.clientSelected as Partner)?.partnerBannerActions;
                this.isArticleModeEnabled = (this.clientSelected as Partner)?.isArticleModeEnabled;
                this.handleRoles();
              }
            },error => {
              this.appStateService.updateIsBusySubject(false);
            }
          );
        }  else {
          this.appStateService.updateIsBusySubject(true);
          this.clientService.getClientById(this.user.vClientId).subscribe(e=>{
            if(e){
              this.appStateService.updateIsBusySubject(false);
              if(e.partnerBannerActions){
                this.partnerBannerActions = e.partnerBannerActions;
                this.handleRoles();
              }
              if(e.isArticleModeEnabled){
                this.isArticleModeEnabled = e.isArticleModeEnabled;
                this.handleRoles();
              }
            }
          },error => {
            this.appStateService.updateIsBusySubject(false);
          });
        }

      } else{
        this.appStateService.updateIsBusySubject(true);
        this.clientsSub = this.clientService.listAllClients().subscribe(vClients => {
          this.appStateService.updateIsBusySubject(false);
          if (this.vClientId) {
              this.clients = vClients.filter(it => (it.id.toString()) == this.vClientId);
              if (this.isAdmin) {
                this.clientSelected = this.clients[0];
                this.userGroup.controls.vClientId.markAsTouched();
                this.onChooseClient(this.clientSelected.uuid);
                this.handleRoles();
              }
            } else {
              this.clients = vClients;
              if (this.isAdmin) {
                this.clientSelected = this.clients.filter(e => e.id.toString() == this.user.vClientId)[0];
                this.userGroup.controls.vClientId.markAsTouched();
                this.onChooseClient(this.clientSelected.uuid);
                this.handleRoles();
              }

              if (this.isGeneralUserAdmin) {
                this.clientSelected = this.clients.filter(e => e.id.toString() == this.user.vClientId)[0];
                this.userGroup.controls.vClientId.markAsTouched();
                this.onChooseClient(this.clientSelected.uuid);
                this.handleRoles();
              }
            }
          }, error => {
            this.appStateService.updateIsBusySubject(false);
          }
        );
      }
    }
    if (this.isGeneralAdmin || this.isGeneralUserAdmin) {
      if(this.user.isPartnerType){
        this.userGroup = this.formBuilder.group({
          firstName: [this.user.firstName, Validators.required],
          lastName: [this.user.lastName, Validators.required],
          mobilePhone: [this.user.mobilePhone, [Validators.required, mobilePhoneNumberValidator]],
          email: [this.user.email, Validators.email],
          password: ['',pwdValidator],
          retypePassword: [''],
          rolesTab: [this.user.roles.split(';'), [Validators.required]],
          vClientId: [this.user.vClientId.toString(), Validators.required]
        }, {validators: mustMatch('password', 'retypePassword')});
      } else {
        if(this.isMyUser){
          this.userGroup = this.formBuilder.group({
            firstName: [this.user.firstName, Validators.required],
            lastName: [this.user.lastName, Validators.required],
            mobilePhone: [this.user.mobilePhone, [Validators.required, mobilePhoneNumberValidator]],
            email: [this.user.email, Validators.email],
            password: ['',pwdValidator],
            retypePassword: [''],
            rolesTab: [this.user.roles.split(';'), [Validators.required]],
            vClientId: [this.user.vClientId?.toString()],
            vetcodeId: [this.vetcodeId]
          }, {validators: mustMatch('password', 'retypePassword')});

        } else {
          this.userGroup = this.formBuilder.group({
            firstName: [this.user.firstName, Validators.required],
            lastName: [this.user.lastName, Validators.required],
            mobilePhone: [this.user.mobilePhone, [Validators.required, mobilePhoneNumberValidator]],
            email: [this.user.email, Validators.email],
            password: ['',pwdValidator],
            retypePassword: [''],
            rolesTab: [this.user.roles.split(';'), [Validators.required]],
            vClientId: [this.user.vClientId?.toString(), Validators.required],
            vetcodeId: [this.vetcodeId]
          }, {validators: mustMatch('password', 'retypePassword')});
        }
      }

    } else {
      this.userGroup = this.formBuilder.group({
        firstName: [this.user.firstName, Validators.required],
        lastName: [this.user.lastName, Validators.required],
        mobilePhone: [this.user.mobilePhone, [Validators.required, mobilePhoneNumberValidator]],
        email: [this.user.email, Validators.email],
        password: ['',pwdValidator],
        retypePassword: [''],
        rolesTab: [this.user.roles.split(';'), [Validators.required]],
        vClientId: [this.user.vClientId?.toString(), Validators.required],
        vetcodeId: [this.vetcodeId]
      }, {validators: mustMatch('password', 'retypePassword')});
    }
  }


  onEdit() {
    if(this.userGroup.valid){
      this.commonUtils.presentYesNoActionSheet('Na pewno chcesz zapisać zmiany?', 'Tak', 'Nie', 'checkmark', 'close', () => {
        this.appStateService.updateIsBusySubject(true);
        console.log(this.userGroup);
        if(this.vetcodeId === 'not-applicable') {
          this.userGroup.controls.vetcodeId.setValue(null);
        }
        const userEdited: User = this.commonUtils.formGroupValuesToObject<User>(new User(), this.userGroup);
        if (!this.isMyUser) {
          userEdited.roles = this.userGroup.get('rolesTab').value?.join(';');
        }

        userEdited.uuid = this.user.uuid;

        if (this.isMyUser) {
          userEdited.roles = this.user.roles;
          userEdited.vClientId = this.user.vClientId;
          userEdited.isPartnerType = this.user.isPartnerType;
        }

        if (!this.isGeneralAdmin && !this.isGeneralUserAdmin) {
          userEdited.vClientId = this.loggedUser.vClientId;
          userEdited.isPartnerType = this.loggedUser.isPartnerType;
          if (this.loggedUser.vetcodeId) {
            userEdited.vetcodeId = this.loggedUser.vetcodeId;
          }
        }

        if(this.user.isPartnerType){
          userEdited.isPartnerType = true;
        }

        console.log(userEdited);
        this.userService.updateUser(userEdited)
          .subscribe((user: User) => {
            console.log(user);
              this.commonUtils.presentInfoToast('Użytkownik został edytowany').then(res => {
                this.userEditedEmitter.emit(user);
                this.appStateService.updateIsBusySubject(false);
              });
            },
            error => {
              switch(error.message) {
                case 'USER_NOT_FOUND': {
                  this.commonUtils.presentAlertToast('Brak zalogowanego użytkownika');
                  break;
                }
                case 'EMPTY_ROLES': {
                  this.commonUtils.presentAlertToast('Brak ról użytkownika');
                  break;
                }
                case 'INVALID_ROLES': {
                  this.commonUtils.presentAlertToast('Błędne role użytkownika');
                  break;
                }
                case 'USER_UNAUTHORIZED': {
                  this.commonUtils.presentAlertToast('Nie masz uprawnień');
                  break;
                }
                case 'EMAIL_ALREADY_EXIST': {
                  this.commonUtils.presentAlertToast('Użytkownik o podanym adresie email istnieje');
                  break;
                }
                case 'MOBILE_PHONE_ALREADY_EXIST': {
                  this.commonUtils.presentAlertToast('Użytkownik o podanym nr. telefonu istnieje');
                  break;
                }
                case 'BAD_VCLIENT': {
                  this.commonUtils.presentAlertToast('Klient nie isnieje');
                  break;
                }
                default: {
                  this.commonUtils.presentAlertToast('Wystąpił błąd podczas edycji użytkownika');
                  this.appStateService.updateIsBusySubject(false);
                  break;
                }
              }

              this.appStateService.updateIsBusySubject(false);
            });
      }, () => {
      });
    } else{
      this.commonUtils.presentAlertToast('Błedny formularz');
    }

  }

  onCancelEdit() {
    if (this.hasUnsavedChanges) {
      this.commonUtils.presentYesNoActionSheet('Masz niezapisane zmiany. Na pewno chcesz zrezygnować z zapisu?', 'Tak', 'Nie', 'checkmark', 'close', () => {
        this.userEditCanceledEmitter.emit(true);
      }, () => {
      });
    } else {
      this.userEditCanceledEmitter.emit(true);
    }
  }

  isFormFieldInvalid(form: FormGroup, fieldName: string, validationType: string) {
    return this.commonUtils.isFormFieldInvalid(form, fieldName, validationType);
  }

  isFormInvalid(form: FormGroup, validationType: string) {
    return this.commonUtils.isFormInvalid(form, validationType);
  }

  private prepareMyUser() {
    this.appStateService.updateIsBusySubject(true);
    this.userSub = this.userService.getUser().pipe(tap(res => {
      this.user = res;
      this.vetcodeId = this.user?.vetcodeId;
      this.appStateService.updateIsBusySubject(false);
    })).subscribe();

  }

  ngOnDestroy(): void {
    console.log('destroyed')
    this.user = null;
    if (this.vetClinicStartContextSub) {this.vetClinicStartContextSub.unsubscribe();}
    if (this.userSub) {this.userSub.unsubscribe();}
    if (this.clientsSub) {this.clientsSub.unsubscribe();}
    if (this.isBusySub) {this.isBusySub.unsubscribe();}
    if (this.pwdSub) {this.pwdSub.unsubscribe();}
    if (this.clinicSub) {this.clinicSub.unsubscribe();}
    if (this.checkCarePlanSub) {this.checkCarePlanSub.unsubscribe();}
  }

  markUnsavedChanges() {
    if (!this.hasUnsavedChanges) {
      this.hasUnsavedChanges = true;
      this.hasUnsavedChangesEmitter.emit(true);
    }
  }

  onChangePwdType() {
    if(this.pwdType === 'password'){
      this.pwdType = 'text';
      this.showPwdIcon = 'eye-outline';
    } else {
      this.pwdType = 'password';
      this.showPwdIcon = 'eye-off-outline';
    }
  }

  generatePwd() {
    this.appStateService.updateIsBusySubject(true);
    this.pwdSub = this.userService.generatePwd().subscribe(pwd=>{
      if(pwd){
        this.pwdType = 'text';
        this.showPwdIcon = 'eye-outline';
        this.userGroup.controls.password.markAsTouched();
        this.userGroup.controls.password.setValue(pwd);
        this.userGroup.controls.retypePassword.setValue(pwd);
        this.commonUtils.presentSimpleInfoToast('Twoje hasło zostało wygenerowane', 'bottom',2000);
      } else {
        this.commonUtils.presentAlertToast('Wystąpił błąd');
      }
      this.appStateService.updateIsBusySubject(false);
    }, error => {
      this.commonUtils.presentAlertToast('Wystąpił błąd');
      this.appStateService.updateIsBusySubject(false);
    });

  }

  selectClinic($event) {
    console.log($event);
    this.vetcodeId = $event.detail.value;
   // this.recommendationSystem = this.clinics.filter(e=>''+e.vetcodeId == this.vetcodeId)[0]?.pragmaticBoxCode != null;
    this.userGroup.controls.vetcodeId.markAsTouched();
    this.markUnsavedChanges();
    this.handleRoles();
  }

   onChooseClient(uuid: any, initialLoad: boolean = true) {
     console.log('wybieramy klienta', initialLoad);
    if(!this.user.isPartnerType){
      this.appStateService.updateIsBusySubject(true);
      this.clinicSub = this.vetClinicService.listClinicsForClient(uuid).subscribe(e => {
        if (e) {
          this.clinics = e;
          console.log('Clinics ==', this.clinics);
          if(initialLoad && !this.user.vetcodeId) {
            this.clinicSelected = null;
            this.vetcodeId = 'not-applicable';
            this.userGroup.controls.vetcodeId.setValue(this.vetcodeId);
            this.userGroup.controls.vetcodeId.markAsTouched();
          }else if (!initialLoad && this.clinics.length === 1) {
            this.clinicSelected = this.clinics[0];
            this.vetcodeId = this.clinicSelected.vetcodeId.toString();
         //   this.recommendationSystem = this.clinicSelected.pragmaticBoxCode != null;
            this.handleRoles();
            this.userGroup.controls.vetcodeId.setValue(this.vetcodeId);
            this.userGroup.controls.vetcodeId.markAsTouched();
          } else if(initialLoad && this.user?.vetcodeId){
            this.clinicSelected = this.clinics.filter(s=>s.vetcodeId.toString()==this.user.vetcodeId)[0];
            this.vetcodeId = this.clinicSelected.vetcodeId.toString();
        //    this.recommendationSystem = this.clinicSelected.pragmaticBoxCode != null;
            this.handleRoles();
            this.userGroup.controls.vetcodeId.setValue(this.vetcodeId);
            console.log('Selected +', this.clinicSelected);
            console.log(this.clinicSelected);
            console.log(this.clinicSelected.clinicName);
            this.userGroup.controls.vetcodeId.markAsTouched();
          }
          this.appStateService.updateIsBusySubject(false);
        } else {
          this.appStateService.updateIsBusySubject(false);
          this.commonUtils.presentAlertToast('Nie znaleziono lecznic dla podanego klienta');
        }
      });
    } else {
      this.partnerBannerActions = (this.clientSelected as Partner).partnerBannerActions;
      this.isArticleModeEnabled = (this.clientSelected as Partner).isArticleModeEnabled;
      this.handleRoles();
    }
  }

  private handleRoles() {
    if (!this.isMyUser) {
      this.roles = [];
      if (this.user.isPartnerType) {
        this.roles.push('sales');
        if(this.isAdmin || this.isGeneralAdmin){
          this.roles.push('sales-manager');
        }
        if(this.partnerBannerActions){
          this.roles.push('partner-banner-actions');
        }

        if(this.isArticleModeEnabled){
          this.roles.push('articles');
          if(this.isAdmin){
            this.roles.push('articles-redactor');
          }
        }
      } else {
        this.roles.push('users');
        this.roles.push('vet-reservations');
        this.roles.push('v-messages');
        this.roles.push('prepaid');
        this.roles.push('orders');
        this.roles.push('lab-test-data');
        this.roles.push('payments-refund');
        if (this.recommendationSystem) {
          this.roles.push('product-recommendations');
        }

        if (this.canAddWellnessPlanRoles) {
          this.roles.push('wellness-plans');
        }

      }
      if (this.isGeneralAdmin || this.isGeneralUserAdmin) {
        this.roles.push('admin');
        if (!this.user.isPartnerType) {
          this.roles.push('clients');
        }
      }
      if ((this.isAdmin && this.clientSelected && this.clientSelected.partnerUUID) || this.isGeneralAdmin) {
        this.roles.push('referrals');
      }
    }
  }

  async onSearchClients() {
    const modal = await this.modalController.create({
      component: ItemFinderComponent,
      componentProps: {
        title: 'Wyszukaj klienta',
        itemType: 'clients',
        nameToFind: this.clientSelected?.name ? this.clientSelected.name : '',
        partnersIncluded: this.user.isPartnerType
      }
    });

    modal.onWillDismiss().then(data => {
      if (data && data.data) {
        this.clinicSelected = null;
        this.clientSelected = data.data;
        this.userGroup.controls.vClientId.setValue(this.clientSelected.id);
        this.onChooseClient(this.clientSelected.uuid, false);
        this.handleRoles();
      }
    });

    return await modal.present();

  }
  canSelectNotApplicable() {
    if(this.isGeneralAdmin || this.isGeneralUserAdmin) {
      return true;
    }
    return this.isAdmin && (this.loggedUser.vetcodeId === null || this.loggedUser.vetcodeId === undefined);

  }

  getTitleForMyUser() {
    return this.isAdmin ? 'Edycja mojego konta - admin' : 'Edycja mojego konta';
  }
}
